import { ApiFragment } from '../../core/records/entities/api-fragment.class';
import { Comparable } from '../../helpers/entities/comparable.interface';
import { Trackable } from '../../helpers/entities/trackable.interface';

interface IFragmentItem {
    fragment: ApiFragment;
    isCurrent: boolean;
}

export class FragmentItem implements IFragmentItem, Comparable, Trackable {
    readonly fragment: ApiFragment;
    readonly isCurrent: boolean;

    constructor({ fragment, isCurrent: currentItem }: IFragmentItem) {
        this.fragment = fragment;
        this.isCurrent = currentItem;
    }

    equals(other: any): boolean {
        if (!(other instanceof FragmentItem)) {
            return false;
        }

        return this.fragment.getFragmentId() === other.fragment.getFragmentId();
    }

    trackBy(): string {
        return this.fragment.getFragmentId();
    }
}
